var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_5437",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#808C96"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_5437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81675 9.01661H12.5167V7.81661H9.81675V9.01661ZM9.81675 6.81661H12.5167V5.61661H9.81675V6.81661ZM3.48341 10.5333H8.81675V10.4666C8.81675 10.0111 8.58064 9.63328 8.10842 9.33328C7.63619 9.03328 6.98341 8.88328 6.15008 8.88328C5.31675 8.88328 4.66397 9.03328 4.19175 9.33328C3.71953 9.63328 3.48341 10.0111 3.48341 10.4666V10.5333ZM6.14875 7.88328C6.48297 7.88328 6.76953 7.76705 7.00841 7.53461C7.2473 7.30215 7.36675 7.01327 7.36675 6.66794C7.36675 6.33372 7.24775 6.04717 7.00975 5.80828C6.77174 5.56939 6.48563 5.44994 6.15141 5.44994C5.81719 5.44994 5.53064 5.56894 5.29175 5.80694C5.05286 6.04495 4.93341 6.33107 4.93341 6.66528C4.93341 7.01061 5.05242 7.29994 5.29042 7.53328C5.52843 7.76661 5.81454 7.88328 6.14875 7.88328ZM0.916748 13.7499V2.23328H15.1001V13.7499H0.916748ZM2.48341 12.1833H13.5167V3.81661H2.48341V12.1833Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio);
export default __webpack_public_path__ + "static/media/bio.18c2f9e643a829a97641edad29b3e600.svg";
export { ForwardRef as ReactComponent };